/**
 * Store Credit API Service
 */

export interface StoreCreditTransaction {
  id: string;
  userId: string;
  bookingId?: string | null;
  type: 'CREDIT' | 'DEBIT' | 'ADMIN_CREDIT' | 'ADMIN_DEBIT' | 'GIFT_CARD_REDEMPTION';
  amount: number;
  description?: string | null;
  createdAt: string;
  booking?: {
    id: string;
    totalAmount: number;
    session: {
      activity: {
        titleCN: string | null;
        titleEN: string | null;
      };
    };
  } | null;
}

class StoreCreditApi {
  private apiUrl: string;

  constructor() {
    this.apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';
  }

  /**
   * Get current user's store credit balance (in cents)
   */
  async getBalance(token: string): Promise<number> {
    const response = await fetch(`${this.apiUrl}/store-credit/balance`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch store credit balance');
    }

    const result = await response.json();
    return result.data.balance;
  }

  /**
   * Get current user's store credit transaction history
   */
  async getTransactions(token: string): Promise<StoreCreditTransaction[]> {
    const response = await fetch(`${this.apiUrl}/store-credit/transactions`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch store credit transactions');
    }

    const result = await response.json();
    return result.data || [];
  }
}

export const storeCreditApi = new StoreCreditApi();
